import { HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { SentryContextService } from '../common/sentry-context.service'
import { Severity } from '@sentry/types'
import { ToastrService } from 'ngx-toastr'
import { MeasurementUnitsPipe } from './measurement-units.pipe'

enum ServerUnitsResponseConverter {
  meters = 'meter',
  kilograms = 'kilogram',
}

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  errorMessageArgs: Array<HttpErrorResponse | any> = []

  constructor(private toastr: ToastrService, private measurementUnitsPipe: MeasurementUnitsPipe) {}

  private unitReplacer = (_match: string, unitIndex: string): string => {
    const index = Number(unitIndex)
    const messageArgs = this.errorMessageArgs[index]
    const { value, precision } = messageArgs
    const units = ServerUnitsResponseConverter[messageArgs.units] ?? messageArgs.units
    return this.measurementUnitsPipe.transform(value, units, precision)
  }

  showErrorMessage = (errorResponse: HttpErrorResponse | any, defaultMessage: string): void => {
    const { error } = errorResponse
    let message: string = !(errorResponse instanceof HttpErrorResponse)
      ? error ?? errorResponse.message ?? defaultMessage
      : typeof error === 'object'
      ? error.error ?? error.message ?? defaultMessage
      : typeof error === 'string'
      ? error
      : errorResponse.statusText

    try {
      this.errorMessageArgs = error?.extra?.message_args
      if (this.errorMessageArgs?.length > 0) {
        message = message.replace(/{(\d)}/g, this.unitReplacer)
      }
    } catch (e) {
      console.error('Failed to convert units.', message, this.errorMessageArgs, errorResponse, e)
    }

    if (this.toastr) {
      this.toastr.error(message)
    }
    SentryContextService.reportMessage(message, Severity.Warning)
  }
}
